import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const EMPLOYMENT_URL =
  "https://yeticoolers.wd5.myworkdayjobs.com/YETI?locations=efc57d642069104ede757f1781c70000&locations=972ab63224d91001fd5308624fe90000";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.column}>
          <h3>Contact</h3>
          <ul>
            <li><Link to="/affiliates">Affiliates</Link></li>
            <li><a href={EMPLOYMENT_URL} target="_blank" rel="noopener noreferrer">Employment</a></li>
            <li><Link to="/shipping-information">Shipping & Delivery</Link></li>
            <li><Link to="/shipping-information#returns">Returns</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
        <div className={styles.column}>
          <h3>Legal</h3>
          <ul>
            <li><Link to="/articles/patents">Patents</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
            <li><a href="#">Report a Vulnerability</a></li>
          </ul>
        </div>
        <div className={styles.newsletter}>
          <h3>Newsletter</h3>
          <p>Sign up for updates, new packs, and field notes from the Ranch.</p>
          <button className={styles.subscribe}>Subscribe</button>
        </div>
        <div className={styles.guarantee}>
          <img
            src="/mystery-ranch-guarantee-logo.svg"
            alt="MYSTERY RANCH Guarantee"
          />
        </div>
      </div>
      <div className={styles.bottom}>© 2026 MYSTERY RANCH BACKPACKS</div>
    </footer>
  );
}
